// extracted by mini-css-extract-plugin
export default {"root":"---------packages-corgi-x-src-components-ToggleBox-Badge-Badge-module__root"};